import { map, catchError } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { User } from '../../shared/models/user';
import { HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { LoginService } from './login.service';
import { decodeJwt } from 'jose';
import { environment } from 'environments/environment';
import { AppConstants } from 'app/app.constants';

@Injectable()
export class AzureLoginService extends LoginService {

  public login(email: string, password: string): Observable<User> {
    let headers = new HttpHeaders({
      authorization: 'Basic ' + btoa(`${email}:${password}`),
      'Ocp-Apim-Subscription-Key': this.subscriptionKey,
    });

    if (environment.environmentName === 'LOCAL') {
      headers = new HttpHeaders({
        authorization: 'Basic ' + btoa(`${email}:${password}`),
      });
    }

    const loginUrl = this.UrlServiceOauthV1 + 'signin';
    // The language in use becomes the preferred language of accounts that
    // don't have one yet (the backend never overwrites an existing one).
    const lang =
      localStorage.getItem(AppConstants.KEYS_LOCAL_STORAGE.ISO_LANG) ||
      AppConstants.LANGUAGES.PT_BR;
    const response = this.http
      .post(loginUrl, null, {
        headers,
        params: { lang },
        responseType: 'text',
        withCredentials: true,
      })
      .pipe(
        map(super.extractData),
        map((token) => this.convert(token)),
        catchError(super.serviceError),
      );

    return response;
  }

  private convert(token: string): User {
    return this.buildUserFromToken(token);
  }

  protected override buildUserFromToken(token: string): User {
    const user = new User();
    const metadata = decodeJwt(token) as any;
    user.access_token = token;
    user.metadata = metadata;
    user.id = metadata.id;
    user.role = metadata.role;
    user.active = metadata.active;
    return user;
  }
}
